import { ApiBase } from "./ApiBase";

class SystemApiBase extends ApiBase {
  public constructor(subPath: string) {
    super(subPath);
  }

  /**
   * Build the appropriate fetch options for System API,
   * which includes the X-Client-Id header.
   */
  protected buildFetchOptions(method: string, data?: unknown): RequestInit {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Client-Id": this.clientId,
    };

    const options: RequestInit = {
      method,
      headers,
    };

    if (data) {
      options.body = JSON.stringify(data);
    }

    return options;
  }
}

export default SystemApiBase;
